import {httpPost} from './base'
// tab1 学习时长数据
export const loadLearnTimeData = params => { return httpPost('loudSpeakLearn/learnTime', params).then(res => res) }
// tab2 学习及技能数据
export const loadLearnAndSkillData = params => { return httpPost('loudSpeakLearn/learnAndSkill', params).then(res => res) }
export const loadModePackagesUsers = params => { return httpPost('loudSpeakLearn/modePackagesUsers', params).then(res => res) }



// WEBPACK FOOTER //
// ./src/api/loud-speak-learn.js